import { cn } from '@eliadmin/core/src/utils/style-utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  style?: React.CSSProperties;
}

/**
 * Page container. `xl` (default) is the Figma layout grid: 1328 px content (layout/container) with
 * page margins 16 px on mobile, 24 px on tablets and 32 px from 1024 px (1328 + 2 × 32 = 1392),
 * centered on wider screens (the 1728 px frame has 200 px margins). Other sizes keep the core widths
 * with the same margins.
 */
export const Container: React.FC<ContainerProps> = ({
  children,
  className,
  size = 'xl',
  style,
}) => (
  <section
    style={style}
    className={cn(
      'mx-auto w-full px-4 md:px-6 lg:px-8',
      'ea-container',
      {
        'ea-container--screen-sm max-w-screen-sm': size === 'sm',
        'ea-container--screen-md max-w-screen-md': size === 'md',
        'ea-container--screen-lg max-w-screen-lg': size === 'lg',
        'ea-container--screen-xl max-w-[1392px]': size === 'xl',
        'ea-container--screen-2xl max-w-screen-2xl': size === '2xl',
      },
      className,
    )}
  >
    {children}
  </section>
);
